import { Editor } from '@tiptap/react'
import { EditorExtensionEnum } from 'client/components/core/tiptap-editor/enums/editor-extensions-enum'
import { ToolbarButtonUi } from 'client/components/core/tiptap-editor/ui/toolbar-button-ui'
import React from 'react'
import { ColorPickerStandaloneControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-standalone-control'
import { useToolbarCommands } from '../../hooks/use-toolbar-commands'

interface InlineStyleControlsProps {
  editor: Editor
}

export const ColorPickerControls = ({ editor }: InlineStyleControlsProps) => {
  const { onSetTextColor } = useToolbarCommands(editor)

  const color: string = editor?.getAttributes('textStyle').color

  return (
    <ToolbarButtonUi active={editor.isActive(EditorExtensionEnum.Color)}>
      <ColorPickerStandaloneControl color={color} update={onSetTextColor} />
    </ToolbarButtonUi>
  )
}
